import React, { Component } from 'react';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import YearMonthDropDownHelper from './IrctcDatePickerHelper';
import autoBind from 'react-autobind';
import '../../styles/inputField.css';
import '../../styles/railSeoSprite.css';
import PropTypes from 'prop-types';

export default class IrctcDatePicker extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      validation: this.props.validations,
      error: this.props.error,
      type: this.props.type,
      loading: false,
      disabled: false,
      valueEntered: false,
      selectedDay: this.props.selectedDay,
      showCalendar: false
      //   loading: this.props.loading,
    };
  }
  showCalendar() {
    this.setState({ showCalendar: true });
  }
  closeCalendar() {
    this.setState({ showCalendar: false });
  }
  handleFocusIn() {
    this.showCalendar();
  }

  updateSelectedDay(day) {
    this.setState({ selectedDay: day });
    this.props.updateParentDate && this.props.updateParentDate(day);
  }
  handleDayClick(day) {
    this.updateSelectedDay(day);
    this.closeCalendar();
  }
  handleDropDownMonthYearClick(day) {
    this.updateSelectedDay(day);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error) {
      this.setState({ error: this.props.error });
    }
  }
  render() {
    const { placeholder, errorMsg, hintText, label, className, customClass, fromDate, toDate } = this.props;
    const { error, type, loading, showCalendar, selectedDay } = this.state;
    return (
      <div
        className={`makeFlex column inputFieldContainer calContainer
        ${error ? 'appendBottom15' : ''} ${customClass} ${error ? 'errorField' : ''}`}
      >
        <span className="railSeoSprite calIcon"></span>
        {label && <label className="latoBold appendBottom10 font14 defaultGreyText">{label}</label>}
        {loading && <span className="blueLoader" />}
        <input
          type={type}
          placeholder={placeholder}
          className={`inputField ${className}`}
          onFocus={this.handleFocusIn}
          value={selectedDay && selectedDay.toLocaleDateString()}
          disabled={loading}
        />
        {hintText && <span className="appendTop10 font12 defaultGreyText">{hintText}</span>}
        {error && errorMsg && <span className="font12 errorText">{errorMsg}</span>}
        {showCalendar && (
          <div>
            <DayPicker
              onDayClick={this.handleDayClick}
              fromMonth={fromDate}
              toMonth={toDate}
              selectedDays={selectedDay}
              month={selectedDay || fromDate}
              captionElement={({ date, localeUtils }) => (
                <YearMonthDropDownHelper
                  date={selectedDay || fromDate}
                  localeUtils={localeUtils}
                  fromDate={fromDate}
                  toDate={toDate}
                  selected={date}
                  onChange={this.handleDropDownMonthYearClick}
                />
              )}
            />
          </div>
        )}
      </div>
    );
  }
}

IrctcDatePicker.propTypes = {
  validations: PropTypes.array,
  error: PropTypes.bool,
  errorMsg: PropTypes.string,
  selectedDay: PropTypes.object,
  updateParentDate: PropTypes.func,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  hintText: PropTypes.string,
  prefixCode: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  customClass: PropTypes.string,
  fromDate: PropTypes.object,
  toDate: PropTypes.object
};
/****************************************************************************************************

 Irctc Date Picker component is a standard input box which can persist a Date Object,
 a Date can be selected using the Drop Down Month , Year by clicking on the day of your choice.
 The input box will reflect this selected Day
 fromDate : Date Object which acts like the lower limit on selecting Date,
        if undefined will default to 1971 January
 toDate   : Date Object which acts like the upper limit on selecting Date,
        if undefined will default to current Year December

 note that
 1. month prop in DayPicker
 2. date prop in YearMonthDropDownHelper
 these must be same all the time
 ****************************************************************************************************/
